import script from "./RunBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunBoard.vue?vue&type=script&setup=true&lang=ts"

import "./RunBoard.vue?vue&type=style&index=0&id=aabd2a70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aabd2a70"]])

export default __exports__